import axios from "axios";
import { EstadosECidades } from "src/util/estados-cidades";

export default class ViaCepService {
  public async getAddressByCep(cep) {
    const res = (await axios.get(`ws/${cep.replace("-", "")}/json`, {
      baseURL: "https://viacep.com.br"
    })).data;
    if (!res.erro) {
      const s = EstadosECidades.find(e => e.uf === res.uf);
      return {
        zipCode: res.cep,
        address: res.logradouro,
        state: s.uf,
        city: res.localidade
      };
    } else {
      return null;
    }
  }
}
